import React from "react";
import CalendarMonth from "./CalendarMonth";
const schedule = [
  [
    {
      country: "bali",
      description: "Sunrise trek with Made in nearby rice fields"
    },
    {
      country: "bali",
      description: "Made's wife teaches us local recipes"
    },
    {
      country: "bali",
      description:
        "All of us fight of food poisoning from the previous day, stay an extra night"
    }
  ],
  [
    {
      country: "thailand",
      description: "Flies to Chiang Mai, Thailand"
    }
  ]
];
export default function June() {
  return (
    <CalendarMonth
      monthName="June"
      startOfMonthOffset={6}
      schedule={schedule}
    />
  );
}
